// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BEL5","controls":"styles_controls__2Vp3a","charLimit":"styles_charLimit__27M8J","input":"styles_input__vUEXB","send":"styles_send__3-1Yk"};